import { useEffect, useState } from "react";
import { Branch } from "../types/branch";

export const useUpdateVisibility = (formData: any, branchData: Branch | undefined, error: string, doberror: boolean) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!branchData) return;

    const hasChanges =
      branchData.Address.address1 !== formData.address1 ||
      branchData.Address.street !== formData.street ||
      branchData.Address.Pincode !== formData.Pincode ||
      branchData.Branch_Opening_date !== formData.branchopeningdate ||
      branchData.Address.selectedCountry !== formData.selectedCountry ||
      branchData.Address.selectedState !== formData.selectedState ||
      branchData.Address.selectedCity !== formData.selectedCity;

    const hasValidPincode = !error;
    const hasValidDate = !doberror;

    setVisible(hasChanges && hasValidPincode && hasValidDate);
  }, [formData, error, doberror, branchData]);

  return visible;
};
